<template>
  <table class="table-responsive table-striped" id="member_table" v-if="teamData != undefined && teamData != null">
    <caption style="text-align: center;font-size: 1.2rem;font-weight: bold;color: #333;">{{teamData.name}}</caption>
    <thead>
    <tr>
      <th v-for="(item, index) in headList" :key="'member_head_' + index">{{item}}</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(item, index) in teamData.players" :key="'member_item_' + index">
      <td><a href="javascript:void(null);" @click="playerItemClicked(index)">{{item.item.name}}</a></td>
      <td><a href="javascript:void(null);" @click="playerItemClicked(index)">{{item.score.field_score == undefined ? 0 : item.score.field_score}}</a></td>
      <td><a href="javascript:void(null);" @click="playerItemClicked(index)">{{item.score.two_point_num == undefined ? 0 : item.score.two_point_num}}</a></td>
      <td><a href="javascript:void(null);" @click="playerItemClicked(index)">{{item.score.three_point_num == undefined ? 0 : item.score.three_point_num}}</a></td>
      <td><a href="javascript:void(null);" @click="playerItemClicked(index)">{{item.score.rebound_num == undefined ? 0 : item.score.rebound_num}}</a></td>
      <td><a href="javascript:void(null);" @click="playerItemClicked(index)">{{item.score.assist_num == undefined ? 0 : item.score.assist_num}}</a></td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "TeamsMemberList",
  props: [
    'teamData',
  ],
  data() {
    return {
      headList: [
        '球员',
        '得分',
        '两分',
        '三分',
        '篮板',
        '助攻'
      ],
    }
  },
  methods: {
    playerItemClicked(index) {
      let item = this.teamData.players[index];

      let l = this.$router.resolve({
        name: 'matchPlayerDetailPage',
        params: {
          id: item.item.id
        }
      });
      window.open(l.href, '_blank');
    }
  }
}
</script>

<style scoped>

  #member_table {
    width: 100%;
    height: 30px;
  }

  #member_table th, #member_table td {
    color: #333;
    line-height: 30px;
    text-align: center;
  }

  #member_table th {
    background-color: #aaa;
  }


  #member_table a {
    text-decoration: none;
    color: #333;
  }

  #member_table a:hover {
    color: #fc1a34;
  }

</style>



// WEBPACK FOOTER //
// src/pages/outer-matches/TeamsMemberList.vue